module.exports = __webpack_public_path__ + "static/404-2a0c60244aa369beb7cbf03913206cb7.jpg";